import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const ContainerPadding = styled(Container)`
  padding: 0px 20px;
`;

export const SectionTitle = styled.div`
  font-size: 28px;
  color: ${themes.colors.yellow.primary};
  margin-bottom: 8px;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and ${themes.queries.minDesktop} {
    flex-direction: row;
  }
`;

export const SectionContainer = styled.div`
  flex: 1;
  border-style: solid;
  border-color: ${themes.colors.neutral.navy};
  background-color: transparent;
  border-top-width: 2px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  padding-top: 20px;
  padding-bottom: 10px;
  padding-left: 16px;
  padding-right: 16px;

  @media screen and ${themes.queries.minTablet} {
    padding-left: 16px;
    padding-right: 16px;
    border-width: 2px;
    margin-bottom: 36px;
  }
`;

export const SectionContainerCalculator = styled(SectionContainer)`
  background-color: ${({ theme }) => theme.colors.neutral.navy};
`;

export const Title = styled.h1`
  font-size: 28px;
  color: white;
  margin-bottom: 28px;
  padding: 20px 20px 0px 20px;
`;

export const AnimatedContentContainer = styled.div`
  overflow: hidden;
  background-color: ${themes.colors.neutral.primaryNavy};
`;

export const ResultsCard = styled.div`
  padding-bottom: 48px;
`;

export const ShadowWrapper = styled.div`
  box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.15);
`;
